import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import NewAssessment from "@/pages/NewAssessment";
import AssessmentProgress from "@/pages/AssessmentProgress";
import Assessments from "@/pages/Assessments";
import Digest from "@/pages/Digest";
import Verify from "@/pages/Verify";
import AuthCallback from "@/pages/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

function AppRoutes() {
  const location = useLocation();
  // Synchronous session_id detection — must run before any protected-route check
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard/:id"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/new"
        element={
          <ProtectedRoute>
            <NewAssessment />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assessments"
        element={
          <ProtectedRoute>
            <Assessments />
          </ProtectedRoute>
        }
      />
      <Route
        path="/digest"
        element={
          <ProtectedRoute>
            <Digest />
          </ProtectedRoute>
        }
      />
      <Route
        path="/assessment/:id/progress"
        element={
          <ProtectedRoute>
            <AssessmentProgress />
          </ProtectedRoute>
        }
      />
      <Route path="/verify/:token" element={<Verify />} />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#1A1F24",
                border: "1px solid #333C47",
                color: "#FFFFFF",
                borderRadius: "4px",
              },
            }}
          />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
